function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleChevronDownFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.969 16a14.969 14.969 0 10-29.937 0 14.969 14.969 0 0029.937 0zM8.516 13.132l1.745-1.748L16 17.123l5.739-5.74 1.745 1.749L16 20.616l-7.484-7.484z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleChevronDownFilled;